// One coach block — Strength / Risk / Try next. Used in the Report panel.
// The colour modifier on .lbl is the only difference between variants.

import type { ReactNode } from "react";

export type CoachBlockKind = "strength" | "risk" | "try-next";

const LABEL: Record<CoachBlockKind, string> = {
  strength: "Strength",
  risk: "Risk",
  "try-next": "Try next",
};

const VARIANT: Record<CoachBlockKind, "s" | "r" | "t"> = {
  strength: "s",
  risk: "r",
  "try-next": "t",
};

export function CoachBlock({
  kind,
  body,
  quote,
  children,
}: {
  kind: CoachBlockKind;
  body?: ReactNode;
  quote?: string;
  children?: ReactNode;
}) {
  return (
    <div className="coach-block">
      <span className={`lbl ${VARIANT[kind]}`}>{LABEL[kind]}</span>
      {children ?? <p>{body}</p>}
      {quote ? <p className="quote">{`"${quote}"`}</p> : null}
    </div>
  );
}
